<template>
  <transition name="fade">
    <div class="cookies" v-if="!loading">
      <div class="container">
        <h3 class="h3 cookies-title">{{ $t('cookies.title') }}</h3>
        <p class="cookies-text" v-html="content"></p>
        <btn @click="$emit('close')">
            {{ $t('cookies.accept') }}
        </btn>
        <btn :theme="'tertiary'" @click="$emit('close')">
            {{ $t('cookies.decline') }}
        </btn>
      </div>
    </div>
  </transition>
</template>

<script>
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Btn
  },
  beforeMount() {
    const { locale } = this.$route.params;
    if (!this.$store.state.terms.item) {
      this.$store.dispatch('terms/get', locale);
    }
  },
  computed: {
    content() {
      // return this.$store.state.terms.item.cookies;
      return null;
    },
    loading() {
      return this.$store.state.terms.requests !== 0;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.cookies {
  @include position(fixed, null null 0 0);
  @include padding(20px null);
  @include size(100%, auto);
  z-index: 1001;
  background-color: rgba($white, .9);
  backdrop-filter: blur(20px);

  .container {
    @include padding(null 16px);
  }

  &-title {
    @include margin(null null 15px);
    color: $primary;
  }

  &-text {
    @include margin(null null 15px);
    color: $primary;
  }

  .btn {
      + .btn {
          margin-left: 15px;
      }
  }
}
</style>
